<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Configuración"
          directory="Evaluador"
          :icon="'grid'"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6 col-md-12">
        <legend class="text-primary">
          <small>Datos del evaluador</small>
        </legend>
      </div>
      <div class="col-sm-6 col-md-12">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
        </div>
      </div>
      <hr />
      <div class="col-12">
        <form class="mb-0" ref="form">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Nombre(s)</label>
                <app-input
                  type="text"
                  v-model="inputs.first_name"
                  placeholder="Ingrese el nombre"
                  :required="true"
                  disabled
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Apellido(s)</label>
                <app-input
                  type="text"
                  v-model="inputs.last_name"
                  placeholder="Ingrese el apellido"
                  :required="true"
                  disabled
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Telefono</label>
                <app-input
                  type="tel-input"
                  v-model="inputs.phone"
                  placeholder="Sin especificicar"
                  :required="true"
                  disabled
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Correo</label>
                <app-input
                  type="email"
                  v-model="inputs.email"
                  placeholder="Sin especificar"
                  :required="true"
                  disabled
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Institución</label>
                <app-input
                  type="text"
                  v-model="inputs.institution"
                  placeholder="Sin especificar"
                  :required="true"
                  disabled
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>País</label>
                <app-input
                    type="select"
                    v-model="inputs.country_id"
                    :list="[
                  { id: '', value: this.$t('select_option') },
                  ...this.$store.state.common.countries,
                ]"
                    :required="true"
                    disabled
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Ciudad</label>
                <app-input
                    type="text"
                    v-model="inputs.city"
                    placeholder="Sin especificar"
                    :required="true"
                    disabled
                />
              </div>
            </div>


            <div class="col-md-6" v-if="inputs.province_id">
              <div class="form-group">
                <label>Provincia</label>
                <app-input
                    type="select"
                    v-model="inputs.province_id"
                    :list="[
                  { id: '', value: this.$t('select_option') },
                  ...this.$store.state.common.provinces,
                ]"
                    :required="true"
                    disabled
                />
              </div>
            </div>

            <div class="col-md-6" v-if="inputs.canton_id">
              <div class="form-group">
                <label>Canton</label>
                <app-input
                    type="select"
                    v-model="inputs.canton_id"
                    :list="[
                  { id: '', value: this.$t('select_option') },
                  ...this.$store.state.common.cantons,
                ]"
                    :required="true"
                    disabled
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Evaluador Externo / Interno</label>
                <app-input
                    type="select"
                    v-model="inputs.scope"
                    :required="true"
                    :list="scope"
                    disabled
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Cargo o Función</label>
                <app-input
                    type="text"
                    v-model="inputs.function"
                    placeholder="Sin especificar"
                    :required="true"
                    disabled
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>¿Cuenta Activa?</label>
                <app-input
                    type="radio-buttons"
                    v-model="inputs.is_active"
                    :list="isActive"
                    disabled
                />
              </div>
            </div>



          </div>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6"></div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="goToCreate()"
          >
            <i data-feather="plus" class="pr-2" />Nueva configuración
          </button>
        </div>
      </div>
    </div>
    <br />
    <app-table :id="tableId" :options="options" @action="getListAction" />

    <detail-modal
      v-if="isAddEditModalActive"
      modalTitle="Añadir Configuración al Evaluador"
      editModalTitle="Editar Evaluador"
      :table-id="tableId"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
    />

    <dashboard-delete-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="modal-delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import * as actions from "../../apiURL";
import { DetailsTableHelpers } from "./DetailsTableHelpers";
import { axiosGet } from "../../../../../../../resources/js/app/helpers/AxiosHelper";

export default {
  extends: CoreLibrary,
  mixins: [FormMixin, DetailsTableHelpers, ModalMixin],
  data() {
    return {
      inputs: {
        is_active: 0
      },
      deleteLoader: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      provinceList: [],
      cantonList: [],
      isActive: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
      scope: [
        { id: null, value: this.$t("select_option") },
        {
          id: "O",
          value: "Interno", //SAE original
        },
        {
          id: "E",
          value: "Externo",
        },
      ],
      typeInstitution: [
        { id: null, value: this.$t("select_option") },
        {
          id: "PU",
          value: "Publica",
        },
        {
          id: "PR",
          value: "Privada",
        },
      ],
      // selectedUrl: "",
      tableId: "evaluator-table",
      rowData: {},
      options: {
        name: "",
        url: `${actions.EVALUATOR_MAINTENANCE}/details/${this.id}`,
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
            component: "detail-modal",
            modalId: "config-modal-add-edit",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "none",
            component: "app-confirmation-modal",
            modalId: "modal-delete",
          },
        ],
        filters: [
           {
            title: "Área",
            type: "drop-down-filter",
            key: "area",
            option: [],
          },
        ],
        showFilter: true,
        showSearch: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },
  props: {
    id: String,
  },
  watch: {
    "$store.state.evaluatorReview.evaluatorType": function () {
      const tmp = this.options.filters.find(
        (element) => element.key === "evaluator_type"
      );
      tmp.option = this.$store.state.evaluatorReview.evaluatorType;
    },
    "inputs.country_id": function () {
      this.provinceList = this.$store.getters.getProvinces(
          this.inputs.country_id
      );
    },

    "inputs.province_id": function () {
      this.cantonList = this.$store.getters.getCantons(this.inputs.province_id);
    },

    "$store.state.common.countries": function () {
      if (this.inputs.i_country_id) {
        this.provinceList = this.$store.getters.getProvinces(
            this.inputs.i_country_id
        );
        this.cantonList = this.$store.getters.getCantons(
            this.inputs.org.i_province_id
        );
      }
    },
  },
  created() {
    this.searchAndSelectFilterOptions();
    this.data_();
    this.options.columns = [...this.tableColumns, this.actionObj];
  },

  methods: {
    returnPage() {
      window.location.href = `/evaluator/maintenance`;
    },

    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    closeAddEditModal() {
      $("#config-modal-add-edit").modal("hide");
      this.isAddEditModalActive = false;
      this.reSetData();
    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == this.$t("Configurar evaluador")) {
        this.selectedUrl = `${actions.EVALUATOR_MAINTENANCE}/config/${rowData.id}`;
        window.location = this.selectedUrl;
      }
      if (actionObj.title == this.$t("delete")) {
        this.openDeleteModal();
      }
      if (actionObj.title == this.$t("edit")) {
        //this.selectedUrl = `${actions.EVALUATOR_MAINTENANCE}/showDetails/${rowData.id}`;
        //this.openAddEditModal();
        this.selectedUrl = `${actions.EVALUATOR_MAINTENANCE}/setting/create-edit/${rowData.id}`;
        window.location = this.selectedUrl;
      }
    },
    goToCreate(){
      window.location = `${actions.EVALUATOR_MAINTENANCE}/setting/create-edit`;
    },
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },
    confirmed() {
      let url = `${actions.EVALUATOR_MAINTENANCE}/destroy-detail/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#modal-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(this.$t("deleted_success"));
        })
        .catch(({ error }) => {})
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
      // this.selectedUrl = "";
    },

    data_() {
      this.deleteLoader = true;
      let url = `${actions.EVALUATOR_MAINTENANCE}/${this.id}`;
      axiosGet(url)
        .then((response) => {
          this.inputs = response.data;
          this.deleteLoader = false;
        })
        .catch(({ error }) => {});
      this.$store.dispatch("getPoliticalDivision");
    },
    searchAndSelectFilterOptions() {
      let url = `accreditations/applications/options`;
      this.axiosGet(url).then((response) => {
        const areaList = this.options.filters.find(element => element.title === 'Área')
        areaList.option = response.data.accreditationAreas;
      } );
    }
  },
};
</script>
